import store from 'store/store';
import { setWall } from 'store/selectedWall/actions';
import glassWallPartTypes from '../../../types/glassWallPartTypes';
import IGlassWallDoor from '../../../../interfaces/IGlassWallDoor';
import getTargetValue from '../../../../../services/forms/getTargetValue';

const handleWoodyDoorLeafColor = (e: any): void => {
  const targetValue = getTargetValue(e);
  const state = store.getState();

  const wall = state.selectedWall.properties;

  if (wall == null) {
    return;
  }

  store.dispatch(
    setWall({
      ...wall,
      woodyDoorLeafColor: targetValue,
      parts: wall.parts.map((part) => {
        if (part.type === glassWallPartTypes.door) {
          part = part as IGlassWallDoor;
          part.woodyDoorLeafColor = targetValue;
          return part;
        }
        return part;
      }),
    })
  );
};

export default handleWoodyDoorLeafColor;
